module.exports = __webpack_public_path__ + "img/turbo-features7.1a8978fe.png";